var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "#005BBB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 400,
    y: 400,
    fill: "#FFD500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUa);
export default __webpack_public_path__ + "static/media/ua.f9cbc20b1a8b52e25c92bad309fd6f47.svg";
export { ForwardRef as ReactComponent };